import { isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { NavigationExtras, Router, UrlTree } from '@angular/router';
import { Response } from 'express';
import { RESPONSE } from '../../express.tokens';
import { PICFLOW_ANALYTICS } from '../picflow-analytics';

@Injectable({
  providedIn: 'root',
})
export class RedirectService {
  private platformId = inject<string>(PLATFORM_ID);
  private response = inject<Response>(RESPONSE, { optional: true });
  private router = inject(Router);
  private analytics = inject(PICFLOW_ANALYTICS);

  public async redirectTo(
    path: string[],
    options?: NavigationExtras & { redirectType?: 'permanent' | 'temporary' }
  ): Promise<UrlTree | boolean> {
    if (!options) options = {};
    if (isPlatformBrowser(this.platformId)) {
      if (!this.analytics.lastUrl) {
        options.replaceUrl = true;
      }

      await this.router.navigate(path, options);
      return false;
    }

    let queryString = '';
    if (options.queryParams) {
      queryString += '?';
      Object.entries(options.queryParams).forEach(([key, value]) => {
        queryString += `${key}=${value}&`;
      });
      queryString = queryString.substring(0, queryString.length - 1);
    }

    this.response?.redirect(options.redirectType === 'permanent' ? 301 : 302, '/' + path.join('/') + queryString);
    return false;
  }

  public externalRedirectTo(url: string, redirectType?: 'permanent' | 'temporary') {
    if (isPlatformBrowser(this.platformId)) {
      window.location.href = url;
    } else {
      this.response?.redirect(redirectType === 'permanent' ? 301 : 302, url);
    }
    return false as const;
  }
}
